


























import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator'
import * as api from '@/modules/geo/api'
import {PostalCode} from '@/modules/geo/types'
import {Colors, notify} from '@/modules/core/notification'

/**
 * Input selector de códigos postales
 *
 * Permite al usuario un código postal de un determinado país y seleccionarlo
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class PostalCodeSearch extends Vue {
    public loading = false
    public items: PostalCode[] = []
    public selected = null

    /**
     * Código postal seleccionado actualmente, ya sea por el usuario o por ser
     * establecido por la propiedad "value" del componente
     */
    public postalCode: PostalCode | null = null

    @Prop({type: [PostalCode, Number], default: null})
    public value: PostalCode

    /**
     * Búsqueda de código postal
     *
     * Función ejecutada 500 ms después de que el usuario termine de escribir en el input.
     * Busca en la api del servicio geodata de artisan el código postal introducido
     * por el usuario y carga en la lista del input todas las coincidencias
     */
    public onSearch = _.debounce(async function (this: PostalCodeSearch, value: string, old: string) {
        if (!value || value === old) {
            return
        }
        this.loading = true
        try {
            this.items = await api.findPostalCodes(value)
        } catch (e) {
            notify('Se ha producido un error al obtener los códigos postales', Colors.Error)
        }
        this.loading = false
    }, 500)

    /**
     * Escucha la propiedad value, la cual puede ser modificada por el componente padre para
     * establecer que código postal se mostrará como código postal seleccionado
     *
     * Si value es un numero se asume que se trata de un identificador interno
     * de un código postal del servicio geodata de Artisan y por lo
     * cual se obtendrá dicho código postal por su id y será
     * mostrado como selección del input.
     */
    @Watch('value', {immediate: true})
    public async onValue (value: PostalCode | number) {
        if (!value) {
            return
        }

        this.loading = true
        const set = (pc: PostalCode) => {
            this.items.push(pc)
            this.postalCode = pc
        }

        // El valor es un código postal, se resetea el componente para mostrar solo
        // dicho código postal
        if (value instanceof PostalCode) {
            set(value)
            this.loading = false

            return
        }

        const postalCode = await api.getPostalCode(value)
        if (!postalCode) {
            notify(`El código postal con id ${value} no existe`, Colors.Error)

            return
        }

        set(postalCode)
        this.loading = false
    }

    public onDeleteKey () {
        this.selected = null
        this.postalCode = null
        this.items = []
        this.$emit('input', null)
    }
}
